import React from 'react';
import { FaInstagram, FaFacebook } from 'react-icons/fa';

function Social() {
  const socialLinks = [
    {
      name: 'Instagram',
      icon: <FaInstagram className="h-5 w-5" />,
      url: 'https://www.instagram.com/luxenergy.hr',
      color: 'hover:text-pink-600',
      hoverBg: 'group-hover:bg-gradient-to-br from-purple-500 via-pink-500 to-orange-500'
    },
    {
      name: 'Facebook',
      icon: <FaFacebook className="h-5 w-5" />,
      url: 'https://web.facebook.com/luxenergydoo',
      color: 'hover:text-blue-600',
      hoverBg: 'group-hover:bg-blue-600'
    }
  ];

  return (
    <div className="flex items-center space-x-4">
      {socialLinks.map((social) => (
        <a
          key={social.name}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          className="group relative"
          aria-label={`Follow us on ${social.name}`}
        >
          <div className={`
            absolute inset-0 rounded-full opacity-0 group-hover:opacity-20 
            transition-all duration-300 ${social.hoverBg}
          `} />
          <div className={`
            relative p-3 text-gray-600 ${social.color} 
            transition-all duration-300 transform 
            hover:scale-110 rounded-full
            hover:shadow-lg hover:shadow-gray-200/50
          `}>
            {social.icon}
          </div>
        </a>
      ))}
    </div>
  );
}

export default Social;